
import React, { useEffect, useState } from 'react'
import { useHistory } from 'react-router-dom'
import { API } from 'aws-amplify'
import StoryTitle from '../components/StoryTitle'
import StoryTable from '../components/StoryTable'
import color from '../shared/color'
import { DonutChart, BubbleChart } from '../d3'
import { Typography, Grid, CircularProgress, Paper } from '@material-ui/core'
import { makeStyles } from '@material-ui/core/styles'
import '../story.css'

function MparReboots() {

    const [title] = useState("MPAR Reboot Tracking")
    const [summary, setSummary] =  useState("File Collection Monitored Devices Using Engineering Services Reboot Definition. Please use the MPAR Reboot workbook for more info.")
    const [categories] = useState(["performance","reboot"])
    const [isLoading, setIsLoading] = useState(true)
    const [data, setData] = useState(null)

    const [facilityLayout] = useState([
        {column:"Facility Name", field:"facilityname"},
        {column:"Customer Name", field: "customername"},
        {column:"Improper Shutdowns",field:"count"},
        {column:"Distinct Devices",field:"nunique"},
    ])
    const [deviceLayout] = useState([
        {column:"DeviceId", field:"deviceid"},
        {column:"Device Name", field: "stationname"},
        {column:"Facility Name",field:"facilityname"},
        {column:"Improper Shutdowns",field:"count"},
    ])
    const [bubbleColor, setBubColor] = useState(null)
    const useStyles = makeStyles({
        table: {
            minWidth: 650,
        },
    })

    let history = useHistory()

    useEffect(() => {
        setBubColor(new Map([
            ["Scheduled_with_permission", "#4e79a7"],
            ["Customer_Managed", "#f28e2c"],
            ["Scheduled_wo_permission", "#59a14f"]
          ]))
        async function fetch() {
            await API.get('qs-web-api', '/data/mpar/reboots.json', {})
                .then((storyData) => {
                    setData(storyData)
                })
                .catch(function (error) {
                    console.log(error)
                })
            setIsLoading(false)
        }
        fetch()
    }, [])

    if (isLoading) {
        return (<div className="circular-progress"><CircularProgress disableShrink /></div>)
    } else {
        return (
            <div id="story">
                <StoryTitle title={title} date={data.date} categories={categories}></StoryTitle>
                <Paper className="storySection">
                <Grid container justify="center" spacing={2} alignItems="stretch" >
                    <div className="description">
                        <Typography>
                            Machine performance assessment reports (MPAR) Reboots is a joint effort from engineering
                            services, technical customer advocacy, and DevOps to find, document, and track customer
                            reboots. Certain customers have a different relationship with handling how the devices
                            reboot and the story's objective is to allow telemetry of the distribution and usage across
                            the system. The system requires file collection which is only for the anesthesia and med station.
                            <p></p>
                            The monitoring effort between the cross-functional teams were used to dive into the log
                            data to show the following shutdown types:
                            <p></p>
                                <li>Normal Shutdowns - Shutdowns from Shell, Maintenance or Software Update.</li>
                                <li>PowerSwitchFlipped&PowerLoss - Power Loss or Power Switched used detected in the logging.</li>
                                <li>Unknown - Unable to use the metrics captured on the device to determine the reboot.</li>
                    </Typography>
                    </div>
                </Grid>
				</Paper>

                <Paper className="storySection">
                <Grid container justify="center" spacing={2} alignItems="stretch" >
                    <div className="description">
                        <Typography variant="h6">
                            All Counts of Reboots for collected MMS Devices
                        </Typography>
                    </div>
                </Grid>
                <Grid container justify="center" spacing={2} alignItems="stretch" >
                    <DonutChart data={data.pieRebootCount} colors={color.defaultScheme} tooltip={"Number of Counts <br> in this time range: <br>"} width={1000} height={400} radius={200}></DonutChart>
                </Grid>

                    <Grid container justify="center" spacing={2} alignItems="stretch" >
                    <div className="description">
                        <Typography >
                            The count of improper shutdowns shows the overall impact to the devices in the field and the low probability that a device can be negatively effected from misuse.
                        </Typography>
                    </div>
                </Grid>
				</Paper>

                <Paper className="storySection">
                <Grid container justify="center" spacing={2} alignItems="stretch" >
                    <div className="description">
                        <Typography variant="h6">
                            Unique Device  Reboots for collected MMS Devices
                        </Typography>
                    </div>
                </Grid>
                <Grid container justify="center" spacing={2} alignItems="stretch" >
                    <DonutChart data={data.pieRebootUnique} colors={color.defaultScheme} tooltip={"Number of Counts <br> in this time range: <br>"} width={1000} height={400} radius={200}></DonutChart>
                </Grid>
                    <Grid container justify="center" spacing={2} alignItems="stretch" >
                    <div className="description">
                        <Typography >
                            The overall unique devices for the issue show how many devices face improper shutdowns in the field.
                        </Typography>
                    </div>
                </Grid>

				</Paper>

                <Paper className="storySection">
                    <Grid container justify="center" spacing={2} alignItems="stretch" >
                    <div className="description">
                        <Typography variant="h6">
                            Top Facilities with Issue Reboots
                        </Typography>
                    </div>
                </Grid>

                     <StoryTable data={data.tableFacility} layout={facilityLayout}></StoryTable>

                    <Grid container justify="center" spacing={2} alignItems="stretch" >
                    <div className="subText">
                        <Typography>
                            The facilities on this list have the worst trend in overall improper shutdowns. Raw data for the specific devices can be found in the mpar reboot workbook.
                        </Typography>
                    </div>
                </Grid>

				</Paper>


                <Paper className="storySection">

                    <Grid container justify="center" spacing={2} alignItems="stretch" >
                    <div className="description">
                        <Typography variant="h6">
                            Top Devices with Issue Reboots
                        </Typography>
                    </div>
                </Grid>

                    <StoryTable data={data.tableDevice} layout={deviceLayout}></StoryTable>



                <Grid container justify="center" spacing={2} alignItems="stretch" >
                    <div className="subText">
                        <Typography>
                            The monitored devices in this list are the worst impacted devices from misused reboots. This shows a customer trend to using improper offs to manage these devices.
                        </Typography>
                    </div>
                </Grid>

                    </Paper>




            </div >
        )
    }
}

export default MparReboots